import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { ModelFilterSchema } from '../model-filter-schema.ts'
import {
  SurveyDetailsSchema,
  SurveySubjectIdSchema,
  SurveyTypeSchema,
} from './survey-details/index.ts'
import { SurveyIdSchema, UserIdSchema } from './unique-id.models.ts'

/**
 * SurveyDomainSelectModel
 */
export const SurveyDomainSelectModelSchema = z.object({
  surveyId: SurveyIdSchema,
  responderId: UserIdSchema,
  details: SurveyDetailsSchema,
})

export type SurveyDomainSelectModel = ZodSimplify<
  typeof SurveyDomainSelectModelSchema
>

/**
 * SurveyDomainInsertModel
 */
export const SurveyDomainInsertModelSchema =
  SurveyDomainSelectModelSchema.partial({ surveyId: true })

export type SurveyDomainInsertModel = ZodSimplify<
  typeof SurveyDomainInsertModelSchema
>

/**
 * SurveyDomainUpdateModel
 */
export const SurveyDomainUpdateModelSchema = z.never()

export type SurveyDomainUpdateModel = ZodSimplify<
  typeof SurveyDomainUpdateModelSchema
>

/**
 * SurveyDomainSelectModelFilters
 */
export const SurveyDomainSelectModelFiltersSchema = z
  .object({
    surveyId: ModelFilterSchema(SurveyIdSchema),
    surveyType: ModelFilterSchema(SurveyTypeSchema),
    responderId: ModelFilterSchema(UserIdSchema),
    subjectId: ModelFilterSchema(SurveySubjectIdSchema),
  })
  .partial()

export type SurveyDomainSelectModelFilters = ZodSimplify<
  typeof SurveyDomainSelectModelFiltersSchema
>

export * from './survey-details/index.ts'
